import extendUserModel from './extendUserModel';
import getLeaveDisplayLabel from './getLeaveDisplayLabel';
import calculateDateParameters from '../calculateDateParameters';
import utils from '../utils';
import context from '../context';
import { EVENT_STATUS } from '../constants';
import gettext from '../lang/gettext';

export default function extendLeaveModel(model, displayMode, days = []) {
  const result = { ...model };

  if (!('displayFullDay' in result)) {
    result.displayFullDay = result.fullDay;
  }

  if (typeof result.dtstart === 'string') {
    Object.assign(result, calculateDateParameters(result));
  }

  result.user = extendUserModel(result.user);

  result.date = utils.formatDate(result.dtstart);
  result.isPast = result.dtend < new Date();
  result.duration = (result.dtend - result.dtstart) / 1000 / 60 / 60;

  const durationInMinutes = result.duration * 60;
  const decimalFormat = context.getDecimalFormat();
  result.displayDuration = utils.getDisplayDuration(durationInMinutes, decimalFormat);
  result.sort = 0;
  result.key = result.id;
  result.canBeSelected = false;

  delete result.displayLabel;
  result.displayLabel = getLeaveDisplayLabel(result, displayMode, days);

  result.monthBlockSecondRow = gettext('Time off');

  if (result.status === EVENT_STATUS.PENDING_ADMIN) {
    result.monthBlockSecondRow += ` • ${gettext('Pending')}`;
  }

  const displayedType = getDisplayedTimeOffType(result);
  if (displayedType) {
    result.monthBlockSecondRow += ` • ${displayedType}`;
  }

  result.auxDisplayLabel = result.monthBlockSecondRow;

  const canSeeOtherUsers = context.me.isManager || context.usersCanSeeOtherSchedules;
  result.monthBlockThirdRow = canSeeOtherUsers ? result.user.fullname : '';
  result.showTimeoffIcon =
    result.status === EVENT_STATUS.PENDING_ADMIN && (context.me.isManager || result.user.isMe);
  result.showBigIcon = result.showTimeoffIcon;

  result.shiftAppearance = {
    day: {
      firstLine: result.displayLabel,
      secondLine: result.auxDisplayLabel,
      timeSource: ['firstLine', 0],
    },
    week: {
      firstLine: result.displayLabel,
      secondLine: result.auxDisplayLabel,
      thirdLine: result.user.fullname,
      timeSource: ['firstLine', 0],
    },
    month: {
      firstLine: result.displayLabel,
      secondLine: result.monthBlockSecondRow,
      thirdLine: result.user.fullname,
      timeSource: ['firstLine', 0],
    },
  };

  return result;
}

function getDisplayedTimeOffType(event) {
  const timeOffTypes = context.getTimeOffTypes();
  if (
    timeOffTypes &&
    timeOffTypes.length > 1 &&
    (context.me.isManager || context.me === event.user)
  ) {
    const found = timeOffTypes.find((type) => type.id === event.leaveTypeId);
    return found ? found.name : null;
  }
}
